// extracted by mini-css-extract-plugin
module.exports = {"contactFooter":"ContactFooter_contactFooter__UKrU0","inView":"ContactFooter_inView__5qa0f"};